module.exports = __webpack_public_path__ + "static/media/appliances2.24593f8c.jpg";